module.exports = __webpack_public_path__ + "static/DSPortraitCropped-2831e3c2156036f372950cb654faa6d8.jpg";